// @ts-nocheck
// Email validation
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Name validation
export const isValidName = (name) => {
  return name.trim().length >= 2;
};

// Validate form data
export const validateLoginForm = (email) => {
  const errors = {};
  
  if (!email) errors.email = 'Email is required';
  else if (!isValidEmail(email)) errors.email = 'Invalid email address';

  return errors;
};

export const validateRegisterForm = (formData) => {
  const errors = {};
  
  if (!formData.firstName) errors.firstName = 'First name is required';
  else if (!isValidName(formData.firstName)) errors.firstName = 'First name must be at least 2 characters';
  if (!formData.lastName) errors.lastName = 'Last name is required';
  else if (!isValidName(formData.lastName)) errors.lastName = 'Last name must be at least 2 characters';
  if (!formData.email) errors.email = 'Email is required';
  else if (!isValidEmail(formData.email)) errors.email = 'Invalid email address';
  return errors;
};
